<template>
    <v-card>
        <v-card-title>
            <v-btn small icon @click="close" color="primary" class="ml-n3 mr-2">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <h2 class="font-weight-regular">
                Search by Number
            </h2>
        </v-card-title>
        <v-divider class="ml-4 mr-5" />
        <v-card-text class="mb-0 pb-0">
            <v-row no-gutters>
                <v-col cols="12">
                    <v-form v-model="valid"
                        ><v-text-field
                            v-model="search"
                            prepend-icon="mdi-database-search"
                            type="number"
                            :rules="[rules.number]"
                    /></v-form>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-btn
                :loading="loading"
                color="primary"
                rounded
                :disabled="!search || search.length == 0 || !valid"
                @click="searchPurchase"
                class="mb-2"
            >
                SEARCH
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import API from '@/services/api'
import moment from 'moment'

export default {
    name: 'FindWO',
    data: () => ({
        loading: false,
        search: null,
        valid: false,
        rules: {
            required: v => !!v || 'Required',
            number: v => (!isNaN(v) && parseInt(v) > 0) || 'Invalid number',
        },
    }),
    methods: {
        ...mapMutations(['setErrorItems']),
        async searchPurchase() {
            try {
                this.loading = true
                const request = await API.findByNumber({
                    number: this.search,
                })
                if (request) {
                    request.dueDate = this.formatDate(
                        request.dueDate.seconds || request.dueDate._seconds
                    )
                    this.$emit('openRequest', request)
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        formatDate(seconds) {
            return moment.unix(seconds).format('YYYY-MM-DD')
        },
        close() {
            this.$emit('close')
        },
    },
}
</script>

<style></style>
